import type { ApiError } from '@/shared/api/client';
import type { ModalityTermRef, ModalityTermTagKind } from '@/shared/api/resources';

/**
 * Dominios e apoio das abas de texto, das coberturas e dos documentos da modalidade
 * (P-PAR-2). Ficam fora dos componentes para que cada arquivo de tela exporte so
 * componente.
 */

/** "Selecione o tipo" da TAG. A lista completa do OnPoint e a confirmar. */
export const tiposDeTag: { value: ModalityTermTagKind; label: string }[] = [
  { value: 'texto', label: 'Texto' },
  { value: 'editor_esteira', label: 'Editor de Texto (Fluxo de esteira)' },
  { value: 'data', label: 'Data' },
  { value: 'automatica', label: 'Automatica' },
];

/** "Tipo de Calculo da Cobertura" do OnPoint. */
export const tiposDeCalculo: { value: string; label: string }[] = [
  { value: '', label: 'Nao informado' },
  { value: 'agravamento_premio', label: 'Agravamento de Premio' },
  { value: 'distribuicao_premio', label: 'Distribuicao de Premio' },
];

/** Forma da importancia segurada da cobertura (InsuredAmountCalculationType). */
export const formasDaImportancia: { value: string; label: string }[] = [
  { value: '', label: 'Nao informada' },
  { value: 'igual_basica', label: 'Igual a da cobertura basica' },
  { value: 'valor_fixo', label: 'Valor fixo' },
  { value: 'percentual_basica', label: 'Percentual da cobertura basica' },
];

/** Chave da consulta do texto, a mesma em todas as abas que o mostram. */
export function chaveDoTexto(referencia: ModalityTermRef): unknown[] {
  return [
    'modality-term',
    referencia.modalityId,
    referencia.coverageId ?? '',
    referencia.family,
    referencia.family === 'objeto'
      ? (referencia.purpose ?? 'cotacao')
      : referencia.kind,
  ];
}

/** O campo que o servidor recusou, ou vazio. */
export function campoRecusado(erro: ApiError | null): string {
  const campo = erro?.details?.field;
  return typeof campo === 'string' ? campo : '';
}
